import { gql } from 'apollo-boost';

export const mailchimpFragment = gql`
  fragment mailchimpFragment on Mailchimp {
    apiKey
    listId
  }
`;